const _DateUtils = class {
  static fromUnixTime(unixTime) {
    return new Date(unixTime * 1e3);
  }
  static getUnixTime(date) {
    return Math.floor(date.getTime() / 1e3);
  }
  static startOfDay(date) {
    const _date = new Date(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
  }
  static subMinutes(date, minutes) {
    const _date = new Date(date);
    _date.setMinutes(_date.getMinutes() - minutes);
    return _date;
  }
};
let DateUtils = _DateUtils;
DateUtils.SECOND = 1e3;
DateUtils.MINUTE = 60 * _DateUtils.SECOND;
DateUtils.HOUR = 60 * _DateUtils.MINUTE;
DateUtils.DAY = 24 * _DateUtils.HOUR;
DateUtils.WEEK = 7 * _DateUtils.DAY;
DateUtils.MONTH = 30 * _DateUtils.DAY;
DateUtils.YEAR = 365 * _DateUtils.DAY;

export { DateUtils };
